<template>
  <div :class="$style.journal_section">
    <MoleculesConsumerHeading title="Popular Journals" sub-title="人気コンテンツ" align="left" variant="sub" />

    <JournalList :external-journals="externalFeatureJournals" gtm-class="gtm_article_item" />

    <template v-if="isCategoryJournals">
      <MoleculesConsumerHeading
        title="Related Journals"
        :sub-title="getTextAboutJournalCategory"
        align="left"
        variant="sub"
      />
      <JournalList :journals="categoryJournals" gtm-class="gtm_article_item" />
    </template>

    <MoleculesConsumerHeading title="Other Journals" sub-title="その他の記事" align="left" variant="sub" />

    <JournalList :article-type="articleType" :journals="otherJournals" gtm-class="gtm_article_item" />

    <div :class="$style.more">
      <AtomsConsumerLink url="`/journals`">
        <MoleculesConsumerButtonWithArrowRight variant="secondary">
          記事をもっと見る
        </MoleculesConsumerButtonWithArrowRight>
      </AtomsConsumerLink>
    </div>

    <ClientOnly>
      <PagePartsProductBrowsingHistory title="閲覧した商品" />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import type { JournalListItemType, JournalListExternalJournal } from "~/types/journal"
import { usePublicPageFindPopularQuery } from "~/gql/urql.generated"

const props = defineProps({
  articleType: {
    type: String,
    required: false,
    default: "",
  },
  otherJournals: {
    type: Array as PropType<JournalListItemType[]>,
    required: false,
    default: () => [],
  },
  categoryJournals: {
    type: Array as PropType<JournalListItemType[]>,
    required: false,
    default: () => [],
  },
  journal: {
    type: Object as PropType<JournalListItemType | undefined>,
    required: false,
    default: undefined,
  },
})

const { data: publicPageManyResult } = await usePublicPageFindPopularQuery({
  variables: {
    filter: {
      is_status: true,
      popular_articles: true,
    },
    limit: 12,
  },
})

const externalFeatureJournals = computed<JournalListExternalJournal[]>(
  () =>
    publicPageManyResult.value?.publicPageFindPopular.map((result) => ({
      title: result.title || "",
      lead_text: result.lead_text || "",
      thumbnail: result.ogp_url || "",
      thumbnail_sp: result.ogp_url || "",
      to: result.absolute_url || "",
    })) ?? [],
)

const isCategoryJournals = computed((): boolean => {
  if (!Array.isArray(props.categoryJournals) || props.categoryJournals.length <= 0) return false
  return true
})

const getTextAboutJournalCategory = computed((): string => {
  if (!props.journal || !props.journal.product_category_id || !props.journal.product_category?.name) return "関連記事"
  return `”${props.journal.product_category?.name}” に関連ある記事`
})
</script>

<style lang="scss" scoped module>
.journal_section {
  width: 95vw;
  margin: 2rem auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @include md {
    max-width: $max-width-lg;
  }
  .more {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
